module.exports = __webpack_public_path__ + "img/clock.7cacfb17.svg";